import React, { FormEvent, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Email } from './Email';
import { Password } from './Password';
import { Submit } from './Submit';
import { LoginProps } from './types';
import { useLocation, useNavigate } from 'react-router-dom';
import { config } from '../../config';

const Login = ({
  email,
  isEmailDisabled = false,
  updateEmail,
  onSubmit,
  message = 'Please enter your email address and password to login.',
}: {
  email: string;
  isEmailDisabled?: boolean;
  updateEmail: React.Dispatch<React.SetStateAction<string>>;
  onSubmit: (props: LoginProps) => void;
  message?: string;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [validated, setValidated] = useState(false);
  const [password, updatePassword] = useState<string>('');
  const featuresByLocation = config.featuresByLocation as Record<string, unknown> | undefined;
  const fromPath = (location.state as { from?: string } | undefined)?.from;
  const fromSegment = fromPath?.split('/').filter(Boolean)[0];
  const returnPath =
    fromSegment && featuresByLocation && Object.keys(featuresByLocation).includes(fromSegment)
      ? `/${fromSegment}`
      : '/';

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity()) {
      onSubmit({ email, password });
    }
    setValidated(true);
  };

  return (
    <Row className="m-1">
      <Col className="col-lg-6 mt-5 offset-lg-3">
        <p>{message}</p>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Email email={email} disabled={isEmailDisabled} updateEmail={updateEmail} />
          <Password password={password} updatePassword={updatePassword} />
          <Submit label="Login" />
        </Form>
        <Button variant="link" onClick={() => navigate(returnPath)}>
          &lt;- Go Back
        </Button>
      </Col>
    </Row>
  );
};

export { Login };
